import * as Immutable from 'immutable';
import * as React from 'react';
import { Fabric, FabricSize } from '../../UIData/_data/Fabrics';
import { MenuItem, FormControl, Select, InputLabel, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

export interface Props {
    onChange: (fabric: Fabric, size: FabricSize) => void
    addGridContainer?: boolean
    displaySize?: boolean
    displayInfo?: boolean
    emptyDefault?: boolean
	fabrics?: Immutable.OrderedMap<number, Fabric>
}

const LargeControl = styled(FormControl)`
	width: 100%;
`;

export default function FabricSelect(props: Props) {
    const [t] = useTranslation('app');
    
	const [idFabric, setIdFabric] = React.useState(props.emptyDefault ? null : props.fabrics.keySeq().first())
	const [idSize, setIdSize] = React.useState(null)
	const [sizeSlug, setSizeSlug] = React.useState('')

    const get_fabric = () => idFabric ? props.fabrics.get(idFabric) : null
	const get_fabric_size = () => idFabric ? get_fabric().get('sizes').get(idSize) as FabricSize : null

	// Select new size when fabric changes
	React.useEffect(() => {
		const fabric = props.fabrics.get(idFabric);
		if(!fabric) return
		
		const sizes = fabric.get('sizes')
		
		let size = sizes.find((entry: FabricSize) => entry.get('slug') == sizeSlug);
		if(size){
			setIdSize(sizes.keyOf(size))
			return
		}

		size = sizes.find((entry: FabricSize) => entry.get('slug') == 'meter');
		if(size){
			setIdSize(sizes.keyOf(size))
			return
		}

		size = sizes.first()
		if(size){
			setIdSize(sizes.keyOf(size))
			return
		}
	
	}, [idFabric])

	// Update when size changes
	React.useEffect(() => {
        const fabric = get_fabric()
		const size = get_fabric_size()
		if(size){
			setSizeSlug(size.get('slug'))
			props.onChange(fabric, size)
		}
	}, [idSize])

	const selectedFabric = idFabric ? props.fabrics.get(idFabric) : null
	
    const Container = props.addGridContainer ? Grid : React.Fragment
    const ContainerProps = props.addGridContainer ? {container: true, spacing: 2} : {}

    return <Container {...ContainerProps}>

        <Grid item xs={12}>
        <InputLabel id="fabric-select--fabric">{t("Fabric")}</InputLabel>
            <LargeControl>
                <Select 
                autoWidth 
                labelId="fabric-select--fabric" 
                value={idFabric || ''} 
                onChange={e => setIdFabric(+e.target.value)}>
                    { props.fabrics.entrySeq().map(([index, fabric]) =>
                        <MenuItem key={index} value={index}>{fabric.get('name')}</MenuItem>
                    )}
                </Select>
            </LargeControl>
        </Grid>
        
        { props.displaySize ? 
            <Grid item xs={12}>
                <InputLabel id="fabric-select--size">{t("Size")}</InputLabel>
                <LargeControl >
                    { selectedFabric ?
                        <Select 
                        label={t("Size")}
                        autoWidth 
                        labelId="fabric-select--size" 
                        value={idSize || ''} 
                        onChange={e => setIdSize(+e.target.value)}>
                            { selectedFabric.get('sizes').entrySeq().map(([index, size]) => 
                                <MenuItem key={index} value={index}>{size.get('name')}</MenuItem>
                            )}
                        </Select>
                    : <Select
                        disabled
                        value={idSize || ''}
                        labelId="fabric-select--size"
                    /> }
                </LargeControl>
            </Grid>
        : <></> }

        { (selectedFabric && props.displayInfo) ?
            <Grid item xs={12}>
                <div className="fabric-tile vertical-variant">
                    <div className="fabric-img-wrapper">
                        <img className="fabric-img" src={"/static/img/pages/fabric/thumbnails/white/"+selectedFabric.get('slug')+".jpg"}/>
                        <img className="fabric-img fabric-img-printed" src={"/static/img/pages/fabric/thumbnails/printed/"+selectedFabric.get('slug')+".jpg"}/>
                    </div>
                    <div className="fabric-tile--details">
                        <p className="uppercase-heading" >{t("COMPOSITION")}</p>
                        <p>{ selectedFabric.getIn(['info','specs','content']) as string }</p>
                        <p className="uppercase-heading" >{t("USES")}</p>
                        <p>{ Object.entries(selectedFabric.getIn(['info','uses'])).map(([title, desc], index) => {
                            return (index > 0 ? ', ':'') + title 
                        })}</p>
                        <div className="specs">
                            {/*<img src="/static/img/pages/fabric/ruler.svg" alt="Ruler icon" />*/}
                            <p>{t("Width")}: { selectedFabric.getIn(['info','specs','width']) as string}</p>
                            {/*<img src="/static/img/pages/fabric/kettlebell.svg" alt="Kettlebell icon" />*/}
                            <p>{t("Weight")}: { selectedFabric.getIn(['info','specs','weight']) as string}</p>
                        </div>
                    </div>
                </div>
            </Grid>
        : <></> }

	</Container>
}